export default "__VITE_ASSET__SIxKCGv4__"